import { render } from "./ClientDashboard.vue?vue&type=template&id=2b32708b&scoped=true"
import script from "./ClientDashboard.vue?vue&type=script&lang=js"
export * from "./ClientDashboard.vue?vue&type=script&lang=js"

import "./ClientDashboard.vue?vue&type=style&index=0&id=2b32708b&lang=scss&scoped=true"

import exportComponent from "/Users/chrisrooster/Documents/Sites/mycelium/server/src/views/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b32708b"]])

export default __exports__